import { Navigate } from "react-router";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useUrlProvider } from "../../useUrlProvider";
import { UserPermissions } from "../../auth/userContextProvider/UserContextProvider.types";

function SettingsRedirect() {
    const { permissions } = useUserContext();
    const urlProvider = useUrlProvider();

    const getFirstSettingsUrl = () => {
        if (permissions.canManageUsers) return urlProvider.getUsersUrl();
        if (permissions.canManageRoles) return urlProvider.getUserRolesUrl();
        if (permissions.canManageMasterData) return urlProvider.getEmailCustomizationUrl();
        if (permissions.canManageAiAdministration) return urlProvider.getAiAdministrationUrl();
        if (permissions.canManageApiKeys) return urlProvider.getApiKeysUrl();
        if (permissions.canManageCustomers) return urlProvider.getCustomersUrl();
        return urlProvider.getForbiddenUrl();
    };

    return <Navigate to={getFirstSettingsUrl()} replace />;
}

export default SettingsRedirect;

export const hasSettingsAccess = (permissions: UserPermissions) => {
    return (
        permissions.canManageCustomers ||
        permissions.canManageUsers ||
        permissions.canManageRoles ||
        permissions.canManageMasterData ||
        permissions.canManageAiAdministration ||
        permissions.canManageApiKeys
    );
};
